export const transformProductList = (data) => data && data.data && data.data.products
